import {
    HEADER_SEARCH_CLEAR,
    HEADER_SEARCH_FETCH_FAILURE,
    HEADER_SEARCH_FETCH_REQUEST,
    HEADER_SEARCH_FETCH_SUCCESS,
} from './actionCreator';

const initialState = {
  loading: false,
  users: [],
  error: null,
};

const headerSearchReducerV2 = (state = initialState, action) => {
  switch (action.type) {
    case HEADER_SEARCH_FETCH_REQUEST:
      return { ...state, loading: true, error: null };
    case HEADER_SEARCH_FETCH_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: null };
    case HEADER_SEARCH_FETCH_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case HEADER_SEARCH_CLEAR:
      return { ...state, loading: false, users: [], error: null };
    default:
      return state;
  }
};

export default headerSearchReducerV2;